<!---------------------------------- CREATE PASSWORD -------------------------------->

<div class='page-body container-col-flex-max' *ngIf='isFirst && !isExpired'>
  <h1 class='header'>
    {{ 'FLEETACTIVATION.fleetActivation' | translate }}
  </h1>
  <form class='center' [formGroup]='passwordForm' (ngSubmit)='onSubmit()' autocomplete='off'>
    <mat-form-field>
      <label>YOUR USERNAME</label>
      <input matInput value='{{ user.email }}' readonly />
    </mat-form-field>

    <mat-form-field>
      <label>CREATE A PASSWORD</label>
      <input matInput type='password' formControlName='password' id='password' />
      <mat-error *ngIf="!passwordForm.get('password').valid && passwordForm.get('password').touched">
        {{ '' | getFormErrorMessage: 'Password':passwordForm.get('password'):'required' }}
        {{ '' | getFormErrorMessage: 'Password':passwordForm.get('password'):'pattern' }}
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <label>CONFIRM PASSWORD</label>
      <input matInput type='password' formControlName='confirmPassword' id='confirmPassword' />
      <mat-error
        *ngIf="!passwordForm.get('confirmPassword').valid && passwordForm.get('confirmPassword').touched"
      >
        {{ '' | getFormErrorMessage: 'Password':passwordForm.get('confirmPassword'):'mustMatch' }}
      </mat-error>
    </mat-form-field>
    <label class='required'>REQUIRED:</label>
    <p>
      - 6 Characters <br />
      - 1 Number <br />
      - 1 Special Character
    </p>
    <button mat-raised-button color='primary' [disabled]='!passwordForm.valid'>ACTIVATE YOUR ACCOUNT</button>
  </form>
</div>

<!---------------------------------- EXPIRED TOKEN -------------------------------->

<div class='page-body container-col-flex-max' *ngIf='isFirst && isExpired'>
  <h1 class='header'>
    {{ 'FLEETACTIVATION.expiredToken' | translate }}
  </h1>
  <h3 class='header'>
    {{ 'FLEETACTIVATION.expiredToken2' | translate }}
  </h3>
</div>

<!---------------------------------- DOWNLOAD APPP -------------------------------->

<div class='page-body container-col-flex-max' *ngIf='isSecond'>
  <h1 class='header'>
    {{ 'FLEETACTIVATION.accountActivated' | translate }}
  </h1>
  <div class='center'>
    <h4 class='subtitle'>
      {{ 'FLEETACTIVATION.downloadApp' | translate }}
    </h4>
    <div class='storeIcon'>
      <a href='https://apps.apple.com/us/app/mentor-by-edriving-amazon-dsp/id1357411961' target='_blank'>
        <img class='centered' [src]="cService.imageRoot + 'app_store_icon.png'" />
      </a>
      <a href='https://play.google.com/store/apps/details?id=com.edriving.mentor.amazon' target='_blank'>
        <img class='centered' [src]="cService.imageRoot + 'gplay_icon.png'" />
      </a>
    </div>
    <h4 class='subtitle'>
      {{ 'FLEETACTIVATION.launchPortal' | translate }}
    </h4>
    <button mat-raised-button color='primary' (click)='navigate()'>GO TO MANAGER PORTAL</button>
  </div>
</div>
